<template>
  <div class="main-body">
    <div class="header">盖瑞一体机</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th"
                border>

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="deviceID" label="设备号"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewData(scope.row)">检测记录</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small background layout="prev, pager, next"
              :total="totalItems"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


      <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
      <Data ref="myData" v-show="showData" v-on:closeData="closeData"  v-on:getList="getList"></Data>


    </div>
  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import {hex_md5_with_china} from "@/common/Base64MD5";
import {getStaffDTO} from "@/utils/auth";

import Add from "./Add";
import Data from "../Comm/Data";

export default {
  name: "Page",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      showData:false,

      tableData: null,
      totalItems: 0,
      pageSize: 8,
      currentPage: 1,

      th: 0,


    };
  },
  components: {Add,Data},
  created() {
    this.init();
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },



    init(){

    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      var _this=this
      this.tableLoading=true


      let data = {
        timeStr: timeStr,
        sign: "",
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        institutionCode:getStaffDTO().institutionDTO.institutionCode,
      };


      data.sign = "";
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


      this.$axios({
        method: "post",
        url: this.$deviceUrl + "GroupGarea/PageByInstitutionCode",
        data: data
      }).then((response) => {
            _this.tableLoading=false
            if (response.data.error == 0) {
              this.tableData = response.data.data.list;
              this.totalItems = response.data.data.total;
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message);
            }
          }).catch(function (error) {
            _this.tableLoading=false
            console.log(error);
          });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要删除该设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        let data = {
          timeStr: timeStr,
          sign: "",
          groupGareaCode: row.groupGareaCode,
        };


        data.sign = "";
        data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


        this.$axios({
              method: "post",
              url: this.$deviceUrl + "GroupGarea/Delete",
              data: data,
            }).then((response) => {
                  //console.log(response);
                  if (response.data.error == 0) {
                    this.$message({message: "删除成功", type: "success",});
                    this.getList();
                  } else if (response.data.error == 1) {
                    this.$message.error(response.data.message);
                  }
                }).catch(function (error) {
                  console.log(error);
                });
          })
          .catch(() => {
            //this.$message({type: "info", message: "已取消操作",});
          });


    },


    viewData(row){
      this.showData = !this.showData;
      this.$refs.myData.init(row.deviceID);
    },
    closeData:function(){
      this.showData = !this.showData;
    },

  },
};
</script>

